import { render, staticRenderFns } from "./StudentWelcome.vue?vue&type=template&id=3f995afc"
import script from "./StudentWelcome.vue?vue&type=script&lang=ts"
export * from "./StudentWelcome.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports